<template>
  <div>
        <a-modal title="导入" :visible="dialog" :footer="null" @cancel="dialog=false">
          <span>
              <input ref="upload" style="display: none" type="file" @change="onUpload" />

              <a-button :loading="loading" @click="onClick" style="margin-right: 10px;"
              >导入</a-button>
              <a href="javacript:void(0)" @click="download">下载模板</a>
        </span>
        </a-modal>
        <Pane />

    <a-card class="container">
      <Padding />
      <input
              ref="upload"
              style="display: none"
              type="file"
              :multiple="false"
              @change="onFileChange"
            />
      <a-form-model layout="inline" :colon="false" :model="form" @keyup.enter.native="query">
            <a-form-model-item label="公司名称">
              <CompanySelector @change="(company) => (selectedCompany = company)" style="width: 200px">
                <a-button block style="text-align: left" class="ellipsis">
                  <div
                    class="left text-hidden selected"
                    v-if="selectedCompany.name"
                  >
                    {{ selectedCompany.name }}
                  </div>
                  <div class="left placeholder" v-else>请选择公司</div>
                </a-button>
              </CompanySelector>
            </a-form-model-item>
            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
            
            <a-button type="primary" v-if="$getPermission($route.path + '/edit')"  @click="dialog=true" style="float: right;margin-top: 5px;">导入分包</a-button>
            <a-button type="primary" style="float: right;margin-top: 5px;margin-right: 10px;" @click.prevent="$router.push($route.path + '/add')">新增分包</a-button>
      </a-form-model>
      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
                    total,
                    current,
                    pageSize,
                    showTotal: (total) => `共 ${total} 条记录`,
                  }"
        rowKey="id"
      >
        <a-table-column title="经办人" data-index='handlerUserName' align='center'/>
        <a-table-column title="项目名称" data-index='project.name' />
        <a-table-column title="分包公司" data-index='companyName' />
        <a-table-column title="发生日期" data-index='date' />
        <a-table-column title="发生金额(万)"  align='right'>
          <template slot-scope="text">
             <Money :money="text.amount" />
          </template>
        </a-table-column>
        <a-table-column align="center" title="操作" width="120px">
          <template slot-scope="text">
            <div>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit')"
                @click.prevent="$router.push($route.path + '/edit?id=' + text.id)"
                style="margin-left: 10px;"
              >编辑</a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/detail')"
                @click.prevent="deleteList(text.id)"
                style="margin-left: 10px;color: red"
              >删除</a>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import moment from 'moment'
import organization from "@/mixins/organization";
import CompanySelector from "@/components/company-selector";
import download from '@/api/download'
import { saveAs } from "file-saver";

function fetchList(params) {
  return request({
       url: '/project-service/sub/pay/list',
       params
  });
}

function upload(data) {
  return request({
    url: "/project-service/projectFin/import",
    method: "post",
    data,
  });
}

function deleteList(id) {
  return request({
       url: '/project-service/sub/pay/del/' + id,
  });
}
function getTemplate() {
  return download({
    url: "/project-service/sub/pay/importTemp",
  });
}

function importChangeList(data) {
    return request({
        url: "project-service/sub/pay/importExc",
        method: 'post',
        data
    });
}
export default {
  mixins: [ watermark,organization],

  components: {
    CompanySelector
  },

  data() {
    return {
      historyAnnualData: [],
      historyProfit: 0,
      statistic: [],
      statisticProfit: 0,
      month: moment().format("YYYY-MM"),

      form: {},
      selectedMonthList: [],
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      uploading: false,
      selectedCompany: {},
      dialog:false,
    };
  },

  computed: {
    monthObj() {
        const item = this.statistic.find(item => item.date === this.month);
        console.log('item',item)
        return item ? item : {}
    }
  },

  mounted() {
    this.selectedMonthList = [moment().format("YYYY") + '-' + '01', '']
    this.getList();
  },

  methods: {
    onUpload(e) {
      console.log(e)
      const files = e.target.files;
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
          data.append("file", files[i]);
      }

      this.loading = true;

      importChangeList(data)
      .then(() => {
      })
      .finally(() => {
      this.loading = false;
      e.target.value = null;
      this.getList();
      });
    },
    onClick(){
        this.$refs.upload.click();
    },
    download(){
        getTemplate().then(blob=>{
            saveAs(blob, "导入模版.xlsx");
        })
    },
    deleteList(id) {
      this.$confirm({
        title: "删除确认",
        content: "确认删除该条记录吗？",
        onOk: () => {
          deleteList(id)
            .then(() => {
              this.getList();
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        },
        onCancel: () => {}
      })
    },
    onSelectProject(value) {
      console.log("value", value);
      this.selectedCompany = value;
      this.form.companyId = value.id;
    },
    monthPanelChange(values) {
      if (values.length === 2) {
        this.selectedMonthList = [
          moment(values[0]).format("YYYY-MM"),
          moment(values[1]).format("YYYY-MM")
        ]
        this.form = {
          ...this.form,
          monthStart: moment(values[0]).format("YYYY-MM"),
          monthEnd: moment(values[1]).format("YYYY-MM"),
        };
      }
    },
    importFile() {
      this.$refs.upload.click();
    },
    onFileChange(e) {
      const files = e.target.files;
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
        data.append("file", files[i]);
      }

      this.uploading = true;

      upload(data)
        .then((res) => {
          console.log("upload res", res);
          if (Array.isArray(res)) {
            if (res.length > 0) {
              alert(res.filter((item, index) => index < 10).join("; "));
            } else {
              this.$message.success("导入成功");
              this.getList();
            }
          }
        })
        .finally(() => {
          this.uploading = false;
          e.target.value = null;
        });
    },
    getList() {
      const { current, pageSize } = this;
      this.loading = true;

      fetchList({
        pageNum: current,
        pageSize: pageSize,
        companyId: this.selectedCompany.id,
      })
        .then(res => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize ? res.totalSize : 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },


    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.selectedCompany = {};
      this.getList();
    },

  }
};
</script>
<style lang="less" scoped>
.card {
  display: flex;

  .item {
    border: 2px solid #f0f0f0;
    margin-right: 12px;
    padding: 12px;
    border-radius: 2px;
    min-width: 240px;
    position: relative;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .extra {
        margin-left: auto;
        cursor: pointer;
      }
    }

    .value {
      font-size: 2em;
      color: #1890ff;
    }

    .setting {
      position: absolute;
      bottom: 12px;
      right: 12px;
      cursor: pointer;
    }
  }

  .active {
    border-color: #1890ff;
  }
}
</style>